/**
 * @author Fernando Ruano
 * @file index.js
 * @description Appointments Container
 */

// Dependencies
import React from 'react';
// import PropTypes from 'prop-types';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * Appointments Container.
 * @return { Node } React Appointments container.
 */
const AppointmentsContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name Appointments.propTypes
 * @type { Object }
 */
AppointmentsContainer.propTypes = {};

/**
 * Default props
 */
AppointmentsContainer.defaultProps = {};

export default AppointmentsContainer;
